
















import { defineComponent, PropType } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "LiveChatUserAvatar",
  components: { BaseAvatar },
  props: {
    user: { type: Object as PropType<UserPublicData | null> },
    referrer: { type: Object as PropType<UserPublicData | null> },
    size: { type: Number, default: 40 },
    borderColor: { type: String, default: "var(--palette-unchanged-bg)" },
  },
});
